import Button from 'react-bootstrap/Button';
import Query from "../../common/Query";
import ListItem from './components/PostListItem';
import POSTS_QUERY from "./queries/POSTS_QUERY";
import { useNavigate } from 'react-router-dom';
import TableList from '../components/TableList';

const PostList = () => {
  const navigate = useNavigate();
  const listItems = () => <Query query={POSTS_QUERY}>
    {({ data: { posts } }: { data: { posts: any[] } }) => {
      const list = posts.map((post, i) =>
        <ListItem post={post} key={post.id} />
      );
      return <>
        <tbody>{list}</tbody>
        <Button className="my-4" onClick={() => navigate(`/admin/create-post/`)}>Add Post</Button>
      </>;
    }}
  </Query>;

  return <TableList>
    {listItems()}
  </TableList>
};

export default PostList;